<div class="footer flex">
  <div class="flex-auto flex items-center container">

  </div>
</div>
